import { backendApi } from './clients'
import { VersionDto } from './dtos/version-dto'

export async function getServiceVersion() {
  const response = await backendApi.get<VersionDto>('/version')
  return response.data
}
